import { createContext, useContext } from "react";

export const TEMPLATE_TYPES = {
  offer: { label: "Member Deal / Offer", vars: ["member_name", "membership_id", "title", "partner", "price"],
           sample: { title: "Desert Safari", partner: "Zola Partner", price: "AED 199" } },
  package: { label: "Tour Package", vars: ["member_name", "membership_id", "title", "price"],
             sample: { title: "Dubai Discovery", price: "AED 2,999 per person" } },
  quick: { label: "Quick Booking Enquiry", vars: ["member_name", "membership_id", "enquiry_type", "from", "to", "travel_date", "passengers", "details"],
           sample: { enquiry_type: "Flights", from: "Dubai", to: "Kochi", travel_date: "2026-08-12", passengers: "2 Adults",
                     details: "From: Dubai\nTo: Kochi\nTravel Date: 2026-08-12\nPassengers: 2 Adults" } },
  featured: { label: "Featured Partner claim", vars: ["member_name", "membership_id", "offer", "partner"],
              sample: { offer: "20% off dining", partner: "Atlantis The Palm" } },
  custom: { label: "Custom Holiday Plan", vars: ["member_name", "membership_id", "title"],
            sample: { title: "Request a Custom Holiday Plan" } },
};

const HELLO = "Hi Zola Rewards[, I'm {member_name}][ (Membership ID: {membership_id})].";
export const DEFAULT_TEMPLATES = {
  offer: `${HELLO} I'd like to enquire about the offer: {title}[ from {partner}][ ({price})].`,
  package: `${HELLO} I'd like to enquire about the {title} package[ ({price})]. Could you share more details?`,
  quick: `${HELLO} I'd like to enquire about {enquiry_type}:\n{details}`,
  featured: `${HELLO} I'd like to claim the {offer} offer[ at {partner}].`,
  custom: `${HELLO} I'd like a custom holiday plan.\nDestination: \nDates: \nTravellers: \nBudget: `,
};

export const SAMPLE_MEMBER = { member_name: "Aisha Al Mansoori", membership_id: "456782910" };

const val = (v) => (v === undefined || v === null ? "" : String(v).replace(/[<>`]/g, "").trim());
const fill = (s, vars) => s.replace(/\{(\w+)\}/g, (_, k) => val(vars[k]));

// [optional segments] are dropped when any placeholder inside them is empty
export function renderTemplate(tpl, vars) {
  const out = tpl.replace(/\[([^[\]]*)\]/g, (_, seg) => {
    const keys = [...seg.matchAll(/\{(\w+)\}/g)].map((m) => m[1]);
    return keys.some((k) => !val(vars[k])) ? "" : fill(seg, vars);
  });
  return fill(out, vars).replace(/[ \t]+([.,!?)])/g, "$1").replace(/\(\s*\)/g, "").replace(/[ \t]{2,}/g, " ").trim();
}

export const MemberEnquiryContext = createContext(null);

// Returns a message builder for logged-in members, or null for guests
export function useMemberMessage(type) {
  const ctx = useContext(MemberEnquiryContext);
  if (!ctx) return null;
  const tpl = ctx.templates?.[type] || DEFAULT_TEMPLATES[type];
  return (vars) => renderTemplate(tpl, { member_name: ctx.member?.name, membership_id: ctx.member?.id, ...vars });
}

export const fieldKey = (label) => (label || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
